import React from "react";

import TableHeaderColumn from "../../shared/TableHeaderColumn.jsx";

import {
  SORT_COMPANY_ASC,
  SORT_COMPANY_DESC,
  SORT_NAME_ASC,
  SORT_NAME_DESC,
  SORT_EMAIL_ASC,
  SORT_EMAIL_DESC,
} from "../../../constants.js";

export default function TableHeader({ sortOption, setSortOption }) {
  const companyOnClick = () =>
    sortOption === SORT_COMPANY_ASC ? setSortOption(SORT_COMPANY_DESC) : setSortOption(SORT_COMPANY_ASC);
  const nameOnClick = () =>
    sortOption === SORT_NAME_ASC ? setSortOption(SORT_NAME_DESC) : setSortOption(SORT_NAME_ASC);
  const emailOnClick = () =>
    sortOption === SORT_EMAIL_ASC ? setSortOption(SORT_EMAIL_DESC) : setSortOption(SORT_EMAIL_ASC);

  return (
    <tr role="row">
      <TableHeaderColumn
        id="company-head"
        text="Contract Holder"
        onClick={companyOnClick}
        title="company name"
        sortOption={sortOption}
        sortDesc={SORT_COMPANY_DESC}
      />
      <TableHeaderColumn id="contracts-head" text="Contract(s)" className="text-center" />
      <TableHeaderColumn id="position-head" text="Position" className="text-center" />
      <TableHeaderColumn
        id="name-head"
        text="Name"
        className="text-center"
        onClick={nameOnClick}
        title="program manager"
        sortOption={sortOption}
        sortDesc={SORT_NAME_DESC}
      />
      <TableHeaderColumn
        id="email-head"
        text="Email"
        className="text-center"
        onClick={emailOnClick}
        title="email addresses"
        sortOption={sortOption}
        sortDesc={SORT_EMAIL_DESC}
      />
      <TableHeaderColumn id="phone-head" text="Phone Numbers" className="text-center" />
    </tr>
  );
}
